<template>
    <div>
        <or-main-title @toFeedback="toFeedback"/>
        <or-services @to-feedback="$emit('to-feedback')"/>
        <or-feedback id="feedback" :settings="feedback_settings"/>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import orMainTitle from './parts/main-page/or-main-title.vue'
import orServices from './parts/main-page/or-services.vue'
import orFeedback from '../global/or-feedback.vue'
export default {
    components: {orMainTitle, orServices, orFeedback},
    props: {
        settings: Object,
    },
    data() {
        return {
            feedback_settings: null,
        }
    },
    watch: {
        settings() {
            this.feedback_settings = this.settings;
        }
    },
}
</script>

<style scoped>

</style>